import React, { useState } from 'react'
import DocumentsCardList from '../../Documents/List/DocumentsCardList'
import Accordion from '../../../Components/Accordion/Accordion'

const Lesson = ({ lesson, userType }) => {
  const [showDocs, toggleDocsVisibility] = useState(false)

  const permission = userType === 'teacher' || userType === 'student'

  const media = lesson.media
    .reduce((all, current) => [...all, ...current.files], [])
    .map((file) => ({
      name: file.fileName,
      url: file.location,
      type: file.fileType,
      size: file.size,
    }))

  return (
    <div className='lesson'>
      <div className='preview'>
        <h1 className={'lessonTitle'}>{lesson.title}</h1>
        <div
          className='lessonDescription'
          dangerouslySetInnerHTML={{ __html: lesson.description }}
        />
      </div>

      {permission && !!media.length && (
        <Accordion
          trigger={
            <h1 className='docsTrigger'>
              {showDocs ? 'Hide' : 'Show'} Documents
            </h1>
          }
          onChange={(newState) => toggleDocsVisibility(newState)}
        >
          <DocumentsCardList files={media} />
        </Accordion>
      )}
    </div>
  )
}

export default Lesson
